<template>
    <div v-if="show">
        <!-- <core-header></core-header> -->
        <div :style="{margin: '0 auto', width: '1200px',padding: '5px',background: '#fff'}">
            <Row :gutter='24'>
                <Col span='22'>
                    <slot></slot>
                </Col>
                <Col span='2'>
                <div class="wrapper-anchor">
                    <div class="anchor">
                        <div class="anchor-line">
                            <div class="anchor-ball" :style="{top:anchorTop + 'px'}"></div>
                        </div>
                        <div class="anchor-box">
                            <div class="anchor-text" v-for="(item,index) in anchorList" :key='index' v-if="item.show"
                                :class="{'anchor-text-active':item.anchorActive}" @click="anchorClick(item,index)">
                                {{item.text}}
                            </div>
                        </div>
                    </div>
                </div>
                </Col>
            </Row>
        </div>
    </div>
    <div v-else>
        <slot></slot>
    </div>
</template>
<script>
// import coreHeader from '@/modules/index/views/coreHeader';
export default {
    name: "anchorNavigation",
    // components: { coreHeader },
    props: {
        data: {
            type: Array,
            default() {
                return []
            },
        },
        show: {
            type: Boolean,
            default: true
        },
    },
    computed: {
        anchorList() {
            let list =  this.data.map((item, index) => {
                let anchorActive = false;
                let show = item.show === undefined ? true : (typeof item.show === 'function' ? item.show() : item.show);
                if(index === 0){
                    anchorActive = true;
                }
                return {
                    ...item,
                    anchorActive,
                    show,
                }
            });
            return list.filter(item => item.show);
        },
    },
    data() {
        return {
            anchorTop: 10,
        }
    },
    methods: {
        anchorClick(item,index){
            this.anchorList.forEach(item => {
                item.anchorActive = false;
            });
            this.anchorList[index].anchorActive = true;
            this.anchorTop = 10 + 30 * index;
            let $el = null;
            let $parent = null;
            let _index = this.$slots.default.findIndex(i => i.elm && i.elm.querySelector && (i.elm.id === item.id || i.elm.querySelector("#" + item.id)));
            if(_index > -1){
                $parent = this.$slots.default[_index].elm;
            }
            $el = $parent.querySelector("#" + item.id) || $parent;
            console.log($el);
            $el && $el.scrollIntoView();
        },
    },
}

</script>
<style lang="less" scoped="scoped">
    .wrapper-anchor {
        position: fixed;
        .anchor {
            position: relative;
            .anchor-line {
                &::before {
                    content:'';
                    position: absolute;
                    width:2px;
                    height: 100%;
                    background-color: #ccc;
                }
                position: absolute;
                height: 100%;
                top:0;
                left: -10px;
                .anchor-ball {
                    position: absolute;
                    left: -3px;
                    top:10px;
                    width:8px;
                    height: 8px;
                    border-radius: 50%;
                    border:1px solid #1890ff;
                }
            }
            .anchor-text {
                cursor: pointer;
                line-height: 30px;
                padding-left: 1px;
                color:#999;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                font-size: 12px;
                width:90px;
            }
            .anchor-text-active {
                color:#1890ff;
            }
        }

    }
</style>
